// Script refactorizado para insertar modelos 3D de cualquier producto
document.addEventListener('DOMContentLoaded', function() {
  // Función para encontrar el contenedor donde se insertará el modelo 3D
  function encontrarContenedorDestino() {
    // Buscar el contenedor con la clase específica
    return document.querySelector('.container-image-3d');
  }
  
  // Función para obtener la URL del modelo 3D directamente desde el DOM
  function obtenerURLModelo3D() {
    // Buscar si ya existe un model-viewer en la página y obtener su URL
    const modeloExistente = document.querySelector('model-viewer');
    if (modeloExistente && modeloExistente.getAttribute('src')) {
      return modeloExistente.getAttribute('src');
    }
    
    // Buscar en miniaturas o enlaces específicos
    const thumbnails = document.querySelectorAll('a[data-item-type="model"], [data-target-id], [data-model-src]');
    for (let thumbnail of thumbnails) {
      const modelUrl = thumbnail.getAttribute('href') || 
                       thumbnail.getAttribute('data-model-src') || 
                       thumbnail.getAttribute('data-src');
      if (modelUrl) return modelUrl;
    }
    
    // Buscar URLs específicas en el DOM
    const scripts = document.querySelectorAll('script');
    for (let script of scripts) {
      const content = script.textContent || '';
      // Buscar URLs de modelos 3D en el contenido del script - patrón más genérico
      const match = content.match(/\/\/spaacio\.mx\/cdn\/shop\/p\/3d\/models\/[^"']+\.glb/);
      if (match) return match[0];
    }
    
    // Si no se encuentra ningún modelo, devolver null
    return null;
  }
  
  // Función para obtener el nombre del producto
  function obtenerNombreProducto() {
    // Intentar obtener desde metadatos
    const metaTitle = document.querySelector('meta[property="og:title"]');
    if (metaTitle && metaTitle.getAttribute('content')) {
      return metaTitle.getAttribute('content');
    }
    
    // Intentar obtener desde el título de la página
    const titulo = document.querySelector('h1.product-title') || 
                   document.querySelector('.product-single__title') || 
                   document.querySelector('.product__title') ||
                   document.querySelector('h1');
    
    if (titulo) {
      return titulo.textContent.trim();
    }
    
    // Por defecto
    return 'Producto';
  }
  
  // Función para crear el contenedor del modelo 3D
  function crearContenedorModelo3D() {
    // Obtener la URL del modelo 3D
    const modeloURL = obtenerURLModelo3D();
    
    // Si no hay modelo disponible, detener el proceso
    if (!modeloURL) {
      console.warn('No se encontró ningún modelo 3D para este producto');
      return null;
    }
    
    // Obtener el nombre del producto para el atributo alt
    const nombreProducto = obtenerNombreProducto();
    
    // Crear el contenedor principal
    const contenedorPrincipal = document.createElement('div');
    contenedorPrincipal.className = 'modelo-3d-container-premium';
    contenedorPrincipal.style.marginTop = '40px';
    contenedorPrincipal.style.marginBottom = '40px';
    //contenedorPrincipal.style.boxShadow = 'rgba(0, 0, 0, 0.1) 0px 5px 20px';
    contenedorPrincipal.style.borderRadius = '8px';
    contenedorPrincipal.style.overflow = 'hidden';
    contenedorPrincipal.style.backgroundColor = 'rgb(255, 255, 255)';
    contenedorPrincipal.style.position = 'relative';
    contenedorPrincipal.style.opacity = '1';
    contenedorPrincipal.style.transform = 'translateY(0px)';
    
    // Crear el encabezado
    const header = document.createElement('div');
    header.style.borderBottom = '1px solid rgb(240, 240, 240)';
    header.style.display = 'flex';
    header.style.justifyContent = 'center';
    header.style.alignItems = 'center';
    header.style.padding = '10px 0px';
    
    // Ícono y título
    const tituloContainer = document.createElement('div');
    tituloContainer.style.display = 'flex';
    tituloContainer.style.alignItems = 'center';
    
    const icono = document.createElement('div');
    icono.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M7 16.3c2.2 0.7 4.7 0.7 6.9 0"></path><path d="M1 10l2.6 8"></path><path d="M23 10l-2.6 8"></path><path d="M12 4L1 10l11 4 11-4-11-6z"></path></svg>';
    icono.style.marginRight = '10px';
    icono.style.color = '#333';
    
    const titulo = document.createElement('h3');
    titulo.textContent = 'Visualización 3D del Producto';
    titulo.style.margin = '0';
    titulo.style.fontWeight = '600';
    titulo.style.fontSize = '18px';
    titulo.style.color = '#333';
    titulo.style.paddingBottom = '0px';
    
    tituloContainer.appendChild(icono);
    tituloContainer.appendChild(titulo);
    header.appendChild(tituloContainer);
    
    // Crear el contenedor del visor 3D
    const viewerContainer = document.createElement('div');
    viewerContainer.style.width = '100%';
    viewerContainer.style.height = '500px';
    viewerContainer.style.position = 'relative';
    viewerContainer.style.backgroundColor = 'rgb(249, 249, 249)';
    viewerContainer.style.display = 'flex';
    viewerContainer.style.justifyContent = 'center';
    viewerContainer.style.alignItems = 'center';
    
    // Crear el model-viewer
    const modelViewer = document.createElement('model-viewer');
    modelViewer.setAttribute('src', modeloURL);
    modelViewer.setAttribute('alt', `Modelo 3D de ${nombreProducto}`);
    modelViewer.setAttribute('camera-controls', 'true');
    modelViewer.setAttribute('auto-rotate', 'true');
    modelViewer.setAttribute('reveal', 'auto');
    modelViewer.style.width = '500px';
    modelViewer.style.height = '500px';
    modelViewer.style.display = 'block';
    modelViewer.style.minHeight = '500px';
    modelViewer.style.position = 'relative';
    modelViewer.style.margin = '0 auto'; // Centrar el modelo
    
    // Obtener el ID del producto si está disponible
    const productIdMeta = document.querySelector('meta[property="product:id"]');
    if (productIdMeta && productIdMeta.getAttribute('content')) {
      modelViewer.setAttribute('data-model-id', productIdMeta.getAttribute('content'));
    }
    
    // Mensaje de instrucciones
    const instrucciones = document.createElement('div');
    instrucciones.className = 'modelo-instrucciones';
    instrucciones.style.position = 'absolute';
    instrucciones.style.bottom = '20px';
    instrucciones.style.left = '20px';
    instrucciones.style.backgroundColor = 'rgba(0, 0, 0, 0.7)';
    instrucciones.style.color = 'white';
    instrucciones.style.padding = '10px 15px';
    instrucciones.style.borderRadius = '30px';
    instrucciones.style.fontSize = '14px';
    instrucciones.style.zIndex = '10';
    instrucciones.style.pointerEvents = 'none';
    instrucciones.style.opacity = '0.9';
    instrucciones.style.display = 'flex';
    instrucciones.style.alignItems = 'center';
    instrucciones.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="margin-right: 8px;"><path d="M15 15s1-1 2-1 3 1 3 1"></path><line x1="11" y1="11" x2="15" y2="15"></line><path d="M9 9a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"></path><path d="M14 15l-3-3a8.9 8.9 0 0 0-4 2"></path><path d="M17 17a5 5 0 0 0-5 5"></path><path d="M7 21a5 5 0 0 1 5-5"></path></svg> Arrastra para rotar | Pellizca para acercar';
    
    // Agregar el footer
    const footer = document.createElement('div');
    footer.style.padding = '15px 25px';
    footer.style.borderTop = '1px solid rgb(240, 240, 240)';
    footer.style.fontSize = '14px';
    footer.style.color = '#666';
    footer.style.display = 'flex';
    footer.style.justifyContent = 'center'; // Centrar el texto
    footer.style.alignItems = 'center';
    
    // Ensamblar el contenedor
    viewerContainer.appendChild(modelViewer);
    viewerContainer.appendChild(instrucciones);
    
    contenedorPrincipal.appendChild(header);
    contenedorPrincipal.appendChild(viewerContainer);
    contenedorPrincipal.appendChild(footer);
    
    return {
      contenedor: contenedorPrincipal,
      modelViewer: modelViewer
    };
  }
  
  // Cargar scripts necesarios
  function cargarScriptsNecesarios() {
    // Verificar si ya existe el script
    if (!document.querySelector('script[src*="model-viewer.min.js"]')) {
      // Cargar script de model-viewer si no está cargado
      const script = document.createElement('script');
      script.src = 'https://unpkg.com/@google/model-viewer/dist/model-viewer.min.js';
      script.type = 'module';
      document.head.appendChild(script);
    }
  }
  
  // Función principal para insertar el modelo 3D
  function insertarModelo3D() {
    // Evitar duplicación
    if (document.querySelector('.modelo-3d-container-premium')) {
      return;
    }
    
    // Encontrar el contenedor donde se insertará el modelo 3D
    const contenedorDestino = encontrarContenedorDestino();
    if (!contenedorDestino) {
      console.warn('No se encontró el contenedor con clase "container-image-3d"');
      return;
    }
    
    // Crear el contenedor del modelo 3D
    const resultado = crearContenedorModelo3D();
    if (!resultado) {
      console.warn('No se pudo crear el contenedor del modelo 3D');
      return;
    }
    
    const { contenedor, modelViewer } = resultado;
    
    // Limpiar el contenedor destino e insertar el modelo 3D
    contenedorDestino.innerHTML = '';
    contenedorDestino.appendChild(contenedor);
    
    // Inicializar UI de Shopify si está disponible
    if (window.Shopify && window.Shopify.ModelViewerUI) {
      setTimeout(function() {
        try {
          new window.Shopify.ModelViewerUI(modelViewer);
        } catch (e) {
          console.warn('Error al inicializar ModelViewerUI:', e);
        }
      }, 500);
    }
    
    // Animación de entrada
    contenedor.style.opacity = '0';
    contenedor.style.transform = 'translateY(20px)';
    contenedor.style.transition = 'opacity 0.5s ease, transform 0.5s ease';
    
    setTimeout(function() {
      contenedor.style.opacity = '1';
      contenedor.style.transform = 'translateY(0px)';
    }, 100);
    
    // Hacer responsivo para móviles
    hacerResponsivo(modelViewer);
  }
  
  // Función para hacer el modelo responsivo
  function hacerResponsivo(modelViewer) {
    function ajustarTamaño() {
      if (window.innerWidth <= 767) {
        // Móviles
        modelViewer.style.width = '350px';
        modelViewer.style.maxWidth = '350px';
      } else if (window.innerWidth <= 991) {
        // Tablets
        modelViewer.style.width = '400px';
      } else {
        // Escritorio
        modelViewer.style.width = '500px';
      }
    }
    
    // Ejecutar al cargar y al cambiar tamaño de ventana
    ajustarTamaño();
    window.addEventListener('resize', ajustarTamaño);
  }
  
  // Cargar scripts necesarios primero
  cargarScriptsNecesarios();
  
  // Esperar a que la página esté completamente cargada
  if (document.readyState === 'complete') {
    setTimeout(insertarModelo3D, 800);
  } else {
    window.addEventListener('load', function() {
      setTimeout(insertarModelo3D, 800);
    });
  }
});